module.exports = __webpack_public_path__ + "static/img/optimize-value.0e793e23.png";